import { render, staticRenderFns } from "./chipsBox.vue?vue&type=template&id=19125f23&"
import script from "./chipsBox.vue?vue&type=script&lang=ts&setup=true&"
export * from "./chipsBox.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports